import { NAV_TYPE_ITEM } from 'constants/app.constant';
import DashboardsIcon from 'assets/dualicons/dashboards.svg?react';
import {
  CloudIcon,
  ChartBarIcon,
  SunIcon,
  BuildingOffice2Icon,
  HeartIcon,
  CalendarIcon,
  QuestionMarkCircleIcon,
  SignalIcon,
} from '@heroicons/react/24/outline';

export const monitoring = {
  id: 'monitoring',
  type: NAV_TYPE_ITEM,
  path: '/monitoring',
  title: 'Monitoring',
  transKey: 'nav.dashboards.monitoring',
  Icon: SignalIcon,
  childs: [
    {
      id: 'monitoring.analytics',
      path: 'monitoring/analytics',
      type: NAV_TYPE_ITEM,
      title: 'Analytics',
      transKey: 'nav.dashboards.analytics',
      Icon: ChartBarIcon,
    },
    {
      id: 'monitoring.daily-profile',
      path: 'reports/daily-profile',
      type: NAV_TYPE_ITEM,
      title: 'Daily Profile',
      transKey: 'nav.dashboards.daily_profile',
      Icon: ChartBarIcon,
    },
    {
      id: 'monitoring.seasonal-analysis',
      path: 'reports/seasonal-analysis',
      type: NAV_TYPE_ITEM,
      title: 'Seasonal Analysis',
      transKey: 'nav.dashboards.seasonal_analysis',
      Icon: ChartBarIcon,
    },
    {
      id: 'monitoring.correlation-analysis',
      path: 'reports/correlation-analysis',
      type: NAV_TYPE_ITEM,
      title: 'Correlation Analysis',
      transKey: 'nav.dashboards.correlation_analysis',
      Icon: ChartBarIcon,
    },
    {
      id: 'monitoring.weather',
      path: 'reports/weather',
      type: NAV_TYPE_ITEM,
      title: 'weather',
      transKey: 'nav.dashboards.weather',
      Icon: ChartBarIcon,
    },

    {
      id: 'monitoring.annual',
      path: 'monitoring/annual',
      type: NAV_TYPE_ITEM,
      title: 'Annual',
      transKey: 'nav.dashboards.annual',
      Icon: ChartBarIcon,
    },
  ],
};

export const baseNavigation = [
  // {
  //   id: 'dashboards',
  //   type: NAV_TYPE_ITEM,
  //   path: '/dashboard',
  //   title: 'Dashboards',
  //   transKey: 'nav.dashboards.dashboards',
  //   Icon: DashboardsIcon,
  // },
  {
    id: 'air-pollution',
    type: NAV_TYPE_ITEM,
    path: '/air-pollution',
    title: 'Air Pollution',
    transKey: 'nav.dashboards.airPollution',
    Icon: CloudIcon,
  },
  monitoring,
  {
    id: 'climate',
    type: NAV_TYPE_ITEM,
    path: '/climate',
    title: 'Climate',
    transKey: 'nav.dashboards.climate',
    Icon: ChartBarIcon,
  },
  {
    id: 'meteorology',
    type: NAV_TYPE_ITEM,
    path: '/meteorology',
    title: 'Meteorology',
    transKey: 'nav.dashboards.meteorology',
    Icon: SunIcon,
  },
  {
    id: 'urbanism',
    type: NAV_TYPE_ITEM,
    path: '/urbanism',
    title: 'Urbanism',
    transKey: 'nav.dashboards.urbanism',
    Icon: BuildingOffice2Icon,
  },
  {
    id: 'health',
    type: NAV_TYPE_ITEM,
    path: '/health',
    title: 'Health',
    transKey: 'nav.dashboards.health',
    Icon: HeartIcon,
  },
  {
    id: 'daily-forecast',
    type: NAV_TYPE_ITEM,
    path: '/daily-forecast',
    title: 'Daily Forecast',
    transKey: 'nav.dashboards.dailyForecast',
    Icon: CalendarIcon,
  },
  {
    id: 'help',
    type: NAV_TYPE_ITEM,
    path: '/help',
    title: 'Help',
    transKey: 'nav.system.help',
    Icon: QuestionMarkCircleIcon,
  },
];
